export enum Type {
    SINGLE = 1,
    MULTI = 2,
}
